// src/instrument.ts
import React from "react";
import * as Sentry from "@sentry/react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";
import { scrubBreadcrumb, scrubEvent, scrubTransaction } from "./utils/sentryScrub";
import { resolveSentryEnvironment } from "./utils/sentryEnvironment";

Sentry.init({
  dsn: "https://0ae5a8b1e05e97aecea3d363fa95ec81@o4509111007641600.ingest.de.sentry.io/4510392322293840",

  // Without this, Sentry defaults every event to "production" and dev-box errors
  // are indistinguishable from real customer ones.
  environment: resolveSentryEnvironment(window.location.hostname),

  sendDefaultPii: false,

  // Strip structured PII (JWT/IBAN/email/EAN/KBO) from every payload before it
  // leaves the browser. Regexes are shared with the backend scrubber.
  beforeSend: scrubEvent,
  beforeSendTransaction: scrubTransaction,
  beforeBreadcrumb: scrubBreadcrumb,

  integrations: [
    // Replace browserTracingIntegration with reactRouterV6BrowserTracingIntegration
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],

  tracesSampleRate: 0.1,
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Record replays only when an error occurs; no always-on session sampling.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});
